<template>
  <div class="cont_section">
    <!-- S : 공통 타이틀 영역 -->
    <mpn-section-title>원하시는 추천팩을 선택 후 신청해보세요</mpn-section-title>
    <!-- E : 공통 타이틀 영역 -->
    <div
      v-if="recommendationsFetched"
      class="recomend_list"
    >
      <template
        v-for="pack in searchedRecommendationPack"
      >
        <recommend-item
          :key="pack.packName"
          ref="recommendationItems"
          :pack-info="pack"
          @selected="onRecommendationSelected"
        />
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import RecommendItem from '@/components/recommendation/RecommendItem.vue';
import { log } from '@/utils/common';

export default {
  name: 'SurveyRecommendationSection',
  components: {
    RecommendItem,
  },
  props: {
    searchedRecommendationPack: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selectedPackCd: null,
    };
  },
  computed: {
    ...mapGetters({
      recommendationsFetched: 'recommendation/recommendationsFetched',
      recommendationPacks: 'recommendation/recommendations',
    }),
  },
  created() {
    log('SurveyRecommendationSection::created', `initial selected pack code: ${this.selectedPackCd}`);
  },
  methods: {
    onRecommendationSelected(packCd) {
      this.selectedPackCd = packCd;

      log('SurveyRecommendationSection::created', `selected pack code: ${this.selectedPackCd}`);

      this.$emit('selected', this.selectedPackCd);
    },
    resetSelection() {
      this.$refs.recommendationItems.forEach((n) => n.resetSelection());
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/survey/main/partial/SurveyRecommendationSection.vue